import { createRef } from 'react';
import { compose, withProps, withState } from 'recompose';
import { connect } from 'react-redux';

import { getEnvironment } from '#src/store/environment/selectors';

export const withCaptchaTokenState = compose(
  connect((state) => ({
    recaptchaSiteKey: getEnvironment(state).RECAPTCHA_SITE_KEY,
  })),
  withProps({ recaptchaRef: createRef() }),
  withState('captchaToken', 'setCaptchaToken')
);
